import { css } from 'styled-components';
export var CHIP_CONTAINER_STYLES = /*#__PURE__*/css(["\n  border-radius: 30px;\n  transition: ", ";\n"], function (_ref) {
  var theme = _ref.theme;
  return theme.transition(['background-color', 'border-color']);
});
export var CHIP_DELETE_BUTTON_STYLES = /*#__PURE__*/css(["\n  transition: ", ";\n"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.transition('background-color');
});